var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"outline-danger"},on:{"click":_vm.pressed}},[_vm._v(_vm._s(_vm.$t('DELETE')))])}
var staticRenderFns = []

export { render, staticRenderFns }